import { Icon } from '@rbilabs/universal-components';
import {
  DetailsContainer,
  InfoText,
  ItemContainer,
  ItemInfoContainer,
  ItemName,
  PictureContainer,
} from 'features/menu/components/menu-reorder-widget/menu-reorder-items-list/styled';

import { getAvailabilityStatusMessage } from 'components/availability-status';
import Picture from 'components/picture';
import SelectionsList from 'components/product/selections-list';
import { t } from 'state/intl/translations';

import { MinimalMappedCartEntry } from './minimal-menu-reorder-widget-types';

export const MinimalMenuReorderItemsListItem = ({ item }: { item: MinimalMappedCartEntry }) => {
  const isAvailable = item.isAvailable;
  const unavailableMessage = getAvailabilityStatusMessage({
    availabilityStatus: item.status,
    dayParts: item.dayParts,
  });

  return (
    <ItemContainer>
      {item?.image && (
        <PictureContainer>
          <Picture alt={item?.name || ''} height="$12" width="$12" image={item.image} />
        </PictureContainer>
      )}
      <DetailsContainer>
        <ItemName isAvailable={isAvailable}>{item?.name}</ItemName>
        {isAvailable ? (
          <SelectionsList selections={item.itemSelections} id={item.id} expandable />
        ) : (
          <ItemInfoContainer>
            <Icon variant="infoFill" />
            <InfoText>{unavailableMessage || t('itemCurrentlyNotAvailable')}</InfoText>
          </ItemInfoContainer>
        )}
      </DetailsContainer>
    </ItemContainer>
  );
};
